import autoMapper from '../../../../../../libraries/utils/auto-mapper';

export function userParser(data: any[]) {
  let mappedData = autoMapper.map(data, {
    '~': 'suggestions',
    id: 'userId',
    user_name: 'username',
    image_id: 'imageId',
    online: 'isOnline',
    display_name: 'displayName',
    registered: 'isRegistered',
    email: 'email'
  });

  let suggestions = mappedData.map(user => {
    user.isRegistered = true;
    return user;
  });

  return suggestions;
}
